/** Single-select chip group: native radios inside a fieldset. */
export default function OptionChips({ name, legend, options, value, onChange, error }) {
  const errorId = error ? `${name}-error` : undefined;

  return (
    <fieldset
      className={`field field--full chips-field${error ? ' is-invalid' : ''}`}
      data-field={name}
      aria-describedby={errorId}
    >
      <legend className="field__label">{legend}</legend>
      <div className="chips">
        {options.map((opt) => (
          <label className="chip" key={opt.value}>
            <input
              type="radio"
              name={name}
              value={opt.value}
              checked={value === opt.value}
              onChange={() => onChange(name, opt.value)}
            />
            <span className="chip__face">
              <span className="chip__dot" aria-hidden="true" />
              {opt.label}
            </span>
          </label>
        ))}
      </div>
      {error && (
        <p className="field__error" id={errorId}>
          {error}
        </p>
      )}
    </fieldset>
  );
}
